import moment from "moment-timezone"

moment.tz.setDefault("Europe/London")
export const momentZ = moment
